import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { STORE_TABS, STORE_TAB_READ_PERMISSIONS } from '~/components/routes/stores/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

// Chaque onglet d'une boutique est une URL distincte ; `/stores/$storeId` n'a pas de contenu propre
// et redirige vers le premier onglet accessible. La fiche est donc ouverte dès qu'AU MOINS UN
// sous-onglet l'est (`{ any }`), et `withRoutePermissions` refuse l'accès quand aucun ne l'est.
export const Route = createFileRoute('/_authenticated/stores/$storeId/')({
  staticData: {
    permission: { any: STORE_TAB_READ_PERMISSIONS },
  },
  params: {
    parse: z.object({ storeId: z.coerce.number() }).parse,
  },
  beforeLoad: ({ context, params }) => {
    const firstAuthorized = STORE_TABS.find(
      (tab) => resolveMissingPermissions(context.ability, tab.permission).length === 0,
    )

    // `withRoutePermissions` a déjà refusé l'accès si aucun onglet n'est accessible : le repli sur
    // le premier onglet ne sert qu'à satisfaire le typage.
    throw redirect({
      to: firstAuthorized?.to ?? STORE_TABS[0].to,
      params: { storeId: params.storeId },
    })
  },
})
withRoutePermissions(Route)
